// extracted by mini-css-extract-plugin
module.exports = {"textOverflow":"editable-text_textOverflow__jaK3B"};